<template>
  <div class="home-page">
    <div class="header">
      <div class="header-logo" @click="gotoSet">
        <img
          class="header-logo-img"
          src="@/assets/home/yb-logo.png"
          v-if="isYb"
        />
        <img class="header-logo-img" src="@/assets/home/logo.png" v-else />
        <span class="header-logo-line"></span>
        <span class="header-logo-title"
          >{{ isYb ? "友帮" : "裹裹帮" }}智能快递柜</span
        >
      </div>
      <div class="header-info">
        <div class="header-info-address" v-if="stationInfo.name">
          {{ stationInfo.name }}
        </div>
        <div class="header-info-time">{{ curTime }}</div>
      </div>
    </div>

    <div class="content-card" :class="`${stationInfo.pickByCode ? 'pickByCode' : ''}`">
      <div class="user-choose">
        <router-link to="/user/pick" class="link">
          <div class="user-choose-item customer" @click="playCustomPick">
            <img src="@/assets/home/home_page_user_img.png" />
            <div class="user-choose-text">
              用户取件
              <span style="width:4em"></span>
            </div>
          </div>
        </router-link>
        <router-link to="/user/search-by-code" class="link" v-if="stationInfo.pickByCode">
          <div class="user-choose-item customer" @click="playCustomPick">
            <img src="@/assets/home/home_page_check_img.png" />
            <div class="user-choose-text">
              单号查件
              <span style="width:4em"></span>
            </div>
          </div>
        </router-link>
        <router-link to="/courier/login" class="link">
          <div class="user-choose-item courier" @click="playCuurierIn">
            <img src="@/assets/home/home_page_courier_img.png" />
            <div class="user-choose-text">
              快递员
              <span style="width:3em"></span>
            </div>
          </div>
        </router-link>
      </div>
      <div class="qr-code">
        <div class="qr-code-img">
          <qr-code
            :text="stationInfo.qrcodeUrl"
            v-if="stationInfo.qrcodeUrl"
          ></qr-code>
        </div>
        <div class="qr-code-text">
          <div class="qr-code-text-main">站点二维码</div>
          <div class="qr-code-text-sub">取件或者投递扫我</div>
        </div>
      </div>
    </div>
    <div class="phone">
      <img src="@/assets/home/home_page_phone_icon.png" />
      <span>电话：{{ stationInfo.phone }}</span>
    </div>
    <van-dialog
      v-model="show"
      title="输入管理密码"
      show-cancel-button
      :show-confirm-button="false"
    >
      <van-password-input
        :value="value"
        :error-info="errorInfo"
        :focused="showKeyboard"
      />
      <van-number-keyboard v-model="value" :show="showKeyboard" />
    </van-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { playVoice } from "../../utils";
import { MAC_KEY } from "@/constant";

const win_height = window.innerHeight;

export default {
  data() {
    return {
      curTime: "",
      timer: null,
      show: false,
      value: "",
      showKeyboard: true,
      errorInfo: "",
      isYb: process.env.VUE_APP_plate === "yb"
    };
  },
  watch: {
    value(value) {
      const passwd = this.passwd;
      if (value.length === 6) {
        if (value === passwd) {
          this.$toast("密码正确");
          uni.reLaunch({ url: "/pages/center/index" });
        } else {
          this.errorInfo = "密码错误";
          this.$toast("密码错误");
        }
      } else {
        this.errorInfo = "";
      }
    }
  },
  computed: {
    ...mapState(["stationInfo"]),
    passwd() {
      return this.stationInfo.phone.slice(5, 11);
    }
  },
  methods: {
    ...mapMutations(["setMac"]),
    ...mapActions(["getStationInfo", "setMacAddress"]),
    gotoSet() {
      this.show = true;
    },
    playCustomPick() {
      // playVoice("customPick");
    },
    playCuurierIn() {
      // playVoice("courierIn");
    },
    play() {
      // playVoice("customPick");
    }
  },
  created() {
    // setTimeout(() => {
    //   this.closeKeyBoard();
    // }, 1000)
    const { mac } = this.$route.query;
    const localMac = localStorage.getItem(MAC_KEY);
    const macStr = mac || localMac;
    if (macStr) {
      this.setMacAddress(macStr);
      this.getStationInfo();

      // this.timer = setInterval(() => {
      //   this.curTime = dayjs().format("YYYY/MM/DD HH:mm:ss");
      // }, 1000);
      //
      // this.$once("hook:beforeDestroy", () => clearInterval(this.timer));
    } else {
      if (!localMac) {
        this.$router.replace("/forbiden");
      }
    }
  }
};
</script>

<style lang="scss">
.home-page {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/home/home_page_bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  .van-dialog__content {
    .van-password-input {
      padding: 1em 0;
    }
    .van-number-keyboard {
      position: static;
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: rem(32);

  &-logo {
    display: flex;
    align-items: center;

    &-img {
      width: rem(64);
      vertical-align: top;
    }

    &-line {
      display: inline-block;
      width: 1px;
      height: rem(54);
      background: $white-color;
      opacity: 0.4;
      margin: 0 rem(19) 0 rem(13);
    }

    &-title {
      font-size: rem(32);
      color: $white-color;
    }
  }

  &-info {
    font-size: rem(24);

    &-address {
      color: $white-color;
      margin-bottom: 10px;
      padding-right: 10px;
      text-align: right;
    }

    &-time {
      color: rgba(1, 1, 1, 0.5);
      text-align: left;
      opacity: 0.5;
      color: #fff;
      width: rem(250);
    }
  }
}

.content-card {
  display: flex;
  justify-content: center;
  .user-choose {
      gap: rem(80);
      padding: rem(40) rem(80);
    }
  &.pickByCode {
    .user-choose {
      gap: rem(36);
      padding: rem(36);
    }
    .qr-code-img {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .link {
    overflow: hidden;
    transition: all 0.05s;
    &:hover {
      background-color: #2196f3;
    }
  }
}

.user-choose {
  display: flex;
  justify-content: space-around;
  background-color: $white-color;
  box-shadow: 0 2px 32px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: center;
  overflow: hidden;
  &-item {
  }

  &-text {
    font-size: rem(28);
    color: #343434;
    margin-top: rem(38);

    span {
      display: block;
      height: 10px;
      background: #1db475;
      margin: 0 auto;
      opacity: 0.4;
      border-radius: 5px;
      position: relative;
      bottom: 10px;
    }
  }
}

.customer,
.courier {
  img {
    width: rem(164);
    height: rem(164);
  }
}

.customer {
  // border-right: 1px dashed #ccc;
}

.qr-code {
  background-color: $white-color;
  box-shadow: 0 2px 32px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: rem(25);
  margin-left: rem(32);

  &-img {
    width: rem(168);
    height: rem(168);
    background-color: rgba(228, 236, 242, 0.4);
    margin: 0 auto;
    padding: rem(18);

    img {
      width: rem(132);
    }
  }

  &-text {
    font-size: rem(24);
    text-align: center;

    &-main {
      margin-top: rem(18);
      color: #343434;
    }

    &-sub {
      margin-top: rem(13);
      color: #a8afb3;
    }
  }
}

.phone {
  text-align: center;
  color: #c0c7cc;
  font-size: rem(24);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: rem(45);

  img {
    width: rem(28);
    height: rem(28);
    margin-right: rem(15);
  }
}
</style>
